'use client';
import React, { useState } from 'react';
import MovieCard from './MovieCard';
import PreRollAdOverlay from './PreRollAdOverlay';

const movies = [
{
  id: 'movie-001',
  title: 'Dune: Prophecy',
  year: 2024,
  rating: 8.2,
  duration: '2h 26m',
  genre: 'Sci-Fi',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1018db743-1773089684347.png",
  posterAlt: 'Dune desert planet landscape with twin suns casting golden light over sand dunes',
  isPremium: false,
  isNew: true,
  views: 142300
},
{
  id: 'movie-002',
  title: 'Oppenheimer',
  year: 2023,
  rating: 8.9,
  duration: '3h 0m',
  genre: 'Dramë',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1642dd3b4-1772188536656.png",
  posterAlt: 'Nuclear explosion mushroom cloud in black and white dramatic photography',
  isPremium: true,
  isNew: false,
  views: 389000
},
{
  id: 'movie-003',
  title: 'Guardians of the Galaxy 3',
  year: 2023,
  rating: 7.9,
  duration: '2h 30m',
  genre: 'Aksion',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_100aedebf-1772378258758.png",
  posterAlt: 'Colorful cosmic nebula with vibrant purple and blue star formations in deep space',
  isPremium: false,
  isNew: false,
  views: 275400
},
{
  id: 'movie-004',
  title: 'Poor Things',
  year: 2023,
  rating: 7.8,
  duration: '2h 21m',
  genre: 'Komedi',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1515223ac-1785083807099.png",
  posterAlt: 'Vintage Victorian-era theatrical stage with dramatic spotlight and ornate curtains',
  isPremium: true,
  isNew: false,
  views: 98700
},
{
  id: 'movie-005',
  title: 'Mission: Impossible 7',
  year: 2023,
  rating: 7.7,
  duration: '2h 43m',
  genre: 'Aksion',
  poster: "https://images.unsplash.com/photo-1633419983774-c140f6f425b0",
  posterAlt: 'High-speed train on mountain tracks with dramatic cliffside scenery at sunset',
  isPremium: false,
  isNew: false,
  views: 312100
},
{
  id: 'movie-006',
  title: 'The Zone of Interest',
  year: 2023,
  rating: 7.4,
  duration: '1h 45m',
  genre: 'Dramë',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1a29e980e-1783857179744.png",
  posterAlt: 'Quiet suburban garden with green grass and trees in warm summer afternoon light',
  isPremium: true,
  isNew: false,
  views: 54200
},
{
  id: 'movie-007',
  title: 'Killers of the Flower Moon',
  year: 2023,
  rating: 7.6,
  duration: '3h 26m',
  genre: 'Thriller',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_15dfd36c5-1772692873771.png",
  posterAlt: 'Vast open American plains with dramatic stormy sky at golden hour',
  isPremium: true,
  isNew: false,
  views: 187300
},
{
  id: 'movie-008',
  title: 'Spider-Man: Across the Spider-Verse',
  year: 2023,
  rating: 8.6,
  duration: '2h 20m',
  genre: 'Animacion',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1befc962a-1786119147843.png",
  posterAlt: 'Colorful comic book style cityscape with vibrant neon colors and dynamic perspective',
  isPremium: false,
  isNew: false,
  views: 421000
},
{
  id: 'movie-009',
  title: 'Alien: Romulus',
  year: 2024,
  rating: 7.3,
  duration: '1h 59m',
  genre: 'Horror',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1d04069af-1767610145436.png",
  posterAlt: 'Dark outer space with a lone spacecraft silhouetted against distant nebula',
  isPremium: false,
  isNew: true,
  views: 203500
},
{
  id: 'movie-010',
  title: 'Challengers',
  year: 2024,
  rating: 7.5,
  duration: '2h 11m',
  genre: 'Romancë',
  poster: "https://images.unsplash.com/photo-1580763850522-504d40a05c50",
  posterAlt: 'Tennis court with dramatic sunlight and net casting shadows on green surface',
  isPremium: true,
  isNew: true,
  views: 76800
},
{
  id: 'movie-011',
  title: 'Inside Out 2',
  year: 2024,
  rating: 7.8,
  duration: '1h 40m',
  genre: 'Animacion',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1d34b3314-1767766209536.png",
  posterAlt: 'Colorful abstract brain-like structures with vibrant emotional color palette',
  isPremium: false,
  isNew: true,
  views: 518700
},
{
  id: 'movie-012',
  title: 'Twisters',
  year: 2024,
  rating: 7.2,
  duration: '2h 2m',
  genre: 'Aventurë',
  poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1ca9b28bf-1772497150181.png",
  posterAlt: 'Dramatic tornado forming over flat American plains with dark storm clouds',
  isPremium: false,
  isNew: true,
  views: 167900
}];


export default function MovieGrid() {
  const [playingMovie, setPlayingMovie] = useState<string | null>(null);
  const [currentMovie, setCurrentMovie] = useState('');

  const handlePlay = (movieId: string, movieTitle: string) => {
    setCurrentMovie(movieTitle);
    setPlayingMovie(movieId);
  };

  return (
    <>
      <div>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-700 text-foreground">
            Të Gjitha Filmat
            <span className="ml-2 text-sm font-500 text-muted-foreground">({movies.length} tituj)</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6 gap-4">
          {movies.map((movie) =>
          <MovieCard
            key={movie.id}
            movie={movie}
            onPlay={() => handlePlay(movie.id, movie.title)} />

          )}
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-center gap-2 mt-10">
          {[1, 2, 3, 4, 5].map((page) =>
          <button
            key={`page-${page}`}
            className={`w-9 h-9 rounded-lg text-sm font-600 transition-all duration-150 ${
            page === 1 ?
            'bg-primary text-primary-foreground' :
            'bg-muted text-secondary-foreground border border-border hover:bg-border'}`
            }>
            
              {page}
            </button>
          )}
          <button className="px-4 h-9 rounded-lg text-sm font-600 bg-muted text-secondary-foreground border border-border hover:bg-border transition-all duration-150">
            Tjetër →
          </button>
        </div>
      </div>

      <PreRollAdOverlay
        open={playingMovie !== null}
        onClose={() => setPlayingMovie(null)}
        movieTitle={currentMovie} />
      
    </>);

}